import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'kwota' })
export class KwotaPipe implements PipeTransform {

  transform(input: number): string {
    return new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN' }).format(input);
  }
}
